var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_356_4084)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.79445 11.8923C6.81739 11.9256 6.84808 11.9528 6.88388 11.9716C6.91968 11.9904 6.95951 12.0003 6.99995 12.0003C7.0404 12.0003 7.08023 11.9904 7.11603 11.9716C7.15183 11.9528 7.18252 11.9256 7.20545 11.8923L9.45545 8.64225C9.4815 8.60476 9.49677 8.56086 9.49961 8.5153C9.50246 8.46975 9.49276 8.42428 9.47158 8.38385C9.45039 8.34342 9.41854 8.30956 9.37946 8.28596C9.34039 8.26237 9.2956 8.24993 9.24995 8.25H4.74995C4.70441 8.25019 4.65979 8.26279 4.62087 8.28644C4.58196 8.3101 4.55023 8.34391 4.5291 8.38425C4.50796 8.42459 4.49822 8.46992 4.50093 8.51538C4.50364 8.56084 4.51868 8.6047 4.54445 8.64225L6.79445 11.8923Z",
    fill: "#003965"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_356_4084)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.7499 4.75003H9.2499C9.29546 4.74988 9.34012 4.73732 9.37907 4.71368C9.41802 4.69005 9.44978 4.65623 9.47095 4.61589C9.49211 4.57554 9.50187 4.53019 9.49918 4.48471C9.49648 4.43922 9.48143 4.39534 9.45565 4.35778L7.20565 1.10778C7.1124 0.973026 6.8879 0.973026 6.7944 1.10778L4.5444 4.35778C4.51836 4.39526 4.50308 4.43917 4.50024 4.48472C4.4974 4.53028 4.5071 4.57575 4.52828 4.61618C4.54946 4.65661 4.58132 4.69046 4.62039 4.71406C4.65946 4.73766 4.70425 4.7501 4.7499 4.75003Z",
    fill: "#013863",
    fillOpacity: 0.45
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_356_4084",
    x: 0,
    y: 7,
    width: 14,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_356_4084"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_356_4084",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_356_4084",
    x: 0,
    y: 0,
    width: 14,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_356_4084"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_356_4084",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDown);
export default __webpack_public_path__ + "static/media/SortDown.85a515e0103e4342316f5e9d8c094c95.svg";
export { ForwardRef as ReactComponent };